export const FLAGGED_ORG_ID = '817551ba-4b1e-4e15-acd0-8665d7245ad8';
export const ALLOWED_USER_ID = 'df32d703-1c81-4643-ac2a-e40f92e9a2e7';

// This flag lets an organization/user open new bills in advance billing
// once the previous bill has reached APPROVED status.
// De default behavior is to only allow opening new bills in advance billing when the previous is CLOSED
export const OPEN_BILL_WHEN_PREVIOUS_APPROVED = 'open-bill-when-previous-approved';
